/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './ClubRegistrationFacilityDetailsValidation';

import NavLinks from '../NavLinks';

import useClubRegistrationNavData from '../../../state/clubRegistration/leftNavigation/UseClubRegistrationNavData';
import useClubRegistrationNewData from '../../../state/clubRegistrationNew/UseClubRegistrationNewData';
import useUsasClubFacilityLinksData from '../../../state/clubFacilityLinks/UseUsasClubFacilityLinksData';
import useUsasClubFileData from '../../../state/clubFile/UseUsasClubFileData';
import ClubRegistrationConstants from '../utils/ClubRegistrationConstants';

import Constants from '@usas/ui-web/utils/Constants';
import useForm from '@usas/ui-web/utils/UseForm';

const SAVING_ERROR_MSG = 'The last action is still saving. Please try again.';
const FILE_TYPE_ERROR_MSG = 'File type not permitted. Please provide a (*.pdf), (*.doc), or (*.docx) file.';
const FILE_MODAL_TITLE = 'Remove Uploaded File?';

const EMERGENCY_ACTION_PLAN = 'Emergency Action Plan';
const EMERGENCY_ACTION_PLAN_TYPE = 'emergencyActionPlan';

const SAFETY_ACTION_PLAN = 'Safety Action Plan';
const SAFETY_ACTION_PLAN_TYPE = 'safetyActionPlan';

const FACILITY_CONTRACT = 'Facility Contract';
const FACILITY_CONTRACT_TYPE = 'facilityContract';

const useClubRegistrationFacilityDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState({ submitButton: '', tryRedirect: false, isFacilityInClubObj: false, facilityId: Constants.DEFAULT_ID, isNewFacility: false, error: '' });
  const [removeFileModalState, setRemoveFileModalState] = useState(getInitialRemoveFileModalState());
  const [submitPrequisitesState, setSubmitPrequisitesState] = useState({ areSubmitPrerequisitesDone: false });

  const { usasClubFacilityLinksState, putUsasClubFacilityLinks, getUsasClubFacilityLinks } = useUsasClubFacilityLinksData();
  const { clubRegistrationNavState, setClubRegistrationNavState } = useClubRegistrationNavData();
  const { clubRegistrationState } = useClubRegistrationNewData()
  const { formState, errorState, setFormState, handleSubmit, onFormValueChanged, onValueTextPairChanged,
    isDirty, isSubmitting } = useForm(getInitialClubFacilityState, submitFormCallback, validate);

  const { usasClubFileUploadState, postUsasClubFile, getFileNameFromSavedUploadUrl, getFileNameFromUrl, getUsasClubFileTemplate,
    getUsasClubFile } = useUsasClubFileData();

  const [fileState, setFileState] = useState({
    clubFacilityEmergencyActionPlanFile: false, clubFacilityEmergencyActionPlanFileUrl: '', clubFacilityEmergencyActionPlanFileName: '',
    clubFacilitySafetyActionPlanFile: false, clubFacilitySafetyActionPlanFileUrl: '', clubFacilitySafetyActionPlanFileName: '',
    clubFacilityContractFile: false, clubFacilityContractFileUrl: '', clubFacilityContractFileName: ''
  });

  const [fileRemoveState, setFileRemoveState] = useState({ isEAPFileRemoved: false, isSAPFileRemoved: false, isContractFileRemoved: false }); 

  function submitFormCallback() {
    // console.log('submitFormCallback called');
    // debugger;
    // putUsasClubFacilityLinks(clubRegistrationState.objData.usasClubId, formState.orgUnitFacilityId, constructObjectForUpdate());
    // setState({ ...state, tryRedirect: true });
  }

  function constructObjectForUpdate() {
    let obj = {
      orgUnitFacilityId: formState.orgUnitFacilityId,
      orgUnitId: formState.orgUnitId,
      facilityId: formState.facilityId,
      effectiveDate: null,
      expirationDate: null,
      facility: undefined,
      clubFacilityContactName: formState.clubFacilityContactName.trim(),
      clubFacilityContactEmailAddress: formState.clubFacilityContactEmailAddress.trim(),
      clubFacilityContactPhoneNumber: formState.clubFacilityContactPhoneNumber.trim(),
      clubFacilityEmergencyActionPlanUrl: fileState.clubFacilityEmergencyActionPlanFileUrl, 
      clubFacilitySafetyActionPlanUrl: fileState.clubFacilitySafetyActionPlanFileUrl, 
      clubFacilityContractUrl: fileState.clubFacilityContractFileUrl,
      ClubFacilityIncludeOnFindATeam: formState.includeInTeamFinder,
      facilityContactName: formState.contactName.trim(),
      facilityContactEmailAddress: formState.contactEmailAddress.trim(),
      facilityContactPhoneNumber: formState.contactPhoneNumber.trim(),
      trainingFacility: formState.trainingFacility
    }

    return obj;
  }

  function constructObjectForFileUpload(type, fileUrl) {
    let eapUrlVal = fileState.clubFacilityEmergencyActionPlanFileUrl;
    let sapUrlVal = fileState.clubFacilitySafetyActionPlanFileUrl;
    let contractUrlVal = fileState.clubFacilityContractFileUrl;

    if (type === EMERGENCY_ACTION_PLAN) {
      eapUrlVal = fileUrl;
    } else if (type === SAFETY_ACTION_PLAN) {
      sapUrlVal = fileUrl;
    } else if (type === FACILITY_CONTRACT) {
      contractUrlVal = fileUrl;
    }

    let obj = {
      orgUnitFacilityId: formState.orgUnitFacilityId,
      orgUnitId: formState.orgUnitId,
      facilityId: formState.facilityId,
      effectiveDate: null,
      expirationDate: null,
      facility: undefined,
      clubFacilityContactName: formState.clubFacilityContactName.trim(),
      clubFacilityContactEmailAddress: formState.clubFacilityContactEmailAddress.trim(),
      clubFacilityContactPhoneNumber: formState.clubFacilityContactPhoneNumber.trim(),
      clubFacilityEmergencyActionPlanUrl: eapUrlVal, 
      clubFacilitySafetyActionPlanUrl: sapUrlVal, 
      clubFacilityContractUrl: contractUrlVal,
      ClubFacilityIncludeOnFindATeam: formState.includeInTeamFinder,
      facilityContactName: formState.contactName.trim(),
      facilityContactEmailAddress: formState.contactEmailAddress.trim(),
      facilityContactPhoneNumber: formState.contactPhoneNumber.trim(),
      trainingFacility: formState.trainingFacility
    }

    return obj;
  }

  const onSaveClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    
    handleSubmit();

    putUsasClubFacilityLinks(clubRegistrationState.objData.usasClubId, formState.orgUnitFacilityId, constructObjectForUpdate());
    setState({ ...state, tryRedirect: true });
  }

  const onCancelGoToClubRegistrationFacilities = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.CLUB_REGISTRATION_FACILITY);
  };

  const onUploadDocumentClicked = (e, type) => {
    if (clubRegistrationState.isSaving === true) {
      setState({ ...state, submitButton: '', tryRedirect: false, error: SAVING_ERROR_MSG });
    }
    else {
      setState({ ...state, submitButton: '', tryRedirect: false, error: '' });

      if (type === EMERGENCY_ACTION_PLAN) {
        setFileRemoveState({ ...fileRemoveState, isEAPFileRemoved: false });
      } else if (type === SAFETY_ACTION_PLAN) {
        setFileRemoveState({ ...fileRemoveState, isSAPFileRemoved: false });
      } else if (type === FACILITY_CONTRACT) {
        setFileRemoveState({ ...fileRemoveState, isContractFileRemoved: false });
      }

      if (e.target.files[0]) {
        const file = e.target.files[0];
        const fileName = clubRegistrationState.objData.usasClubId + ' ' + e.target.files[0].name;
        const fileType = e.target.files[0].type;

        if (fileType === Constants.FILE_TYPE_PDF ||
          fileType === Constants.FILE_TYPE_DOC ||
          fileType === Constants.FILE_TYPE_DOCX) {
          setFileState({
            ...fileState,
            clubFacilityEmergencyActionPlanFile: type === EMERGENCY_ACTION_PLAN ? true : false,
            clubFacilitySafetyActionPlanFile: type === SAFETY_ACTION_PLAN ? true : false,
            clubFacilityContractFile: type === FACILITY_CONTRACT ? true : false
          });
          setState({ ...state, submitButton: '', tryRedirect: false, error: '' });
          postUsasClubFile(file, fileName);
        }
        else {
          setState({ ...state, submitButton: '', tryRedirect: false, error: FILE_TYPE_ERROR_MSG });
        }
      }
    }
  }

  const onRemoveDocumentClicked = (e, type) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setRemoveFileModalState({ ...getInitialRemoveFileModalState() });
    if (clubRegistrationState.isSaving === true) {
      setState({ ...state, submitButton: '', tryRedirect: false, error: SAVING_ERROR_MSG });
    }
    else {
      const navIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.FACILITY);
      clubRegistrationNavState[navIndex] =
      {
        ...clubRegistrationNavState[navIndex],
        isCurrent: true,
        isComplete: false,
        isVisited: true,
        arePrerequisitesDone: true
      }
      const submitNavIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.SUBMIT)
      clubRegistrationNavState[submitNavIndex] =
      {
        ...clubRegistrationNavState[submitNavIndex],
        isCurrent: false,
        isComplete: false,
        isVisited: false,
        arePrerequisitesDone: false
      }
      setSubmitPrequisitesState({ ...submitPrequisitesState, areSubmitPrerequisitesDone: false });
      setClubRegistrationNavState(clubRegistrationNavState);
      setState({ ...state, submitButton: '', tryRedirect: false, error: '' });

      if (type === EMERGENCY_ACTION_PLAN) {
        setFileState({
          ...fileState,
          clubFacilityEmergencyActionPlanFile: false,
          clubFacilityEmergencyActionPlanFileUrl: '',
          clubFacilityEmergencyActionPlanFileName: ''
        });
      }
      else if (type === SAFETY_ACTION_PLAN) {
        setFileState({
          ...fileState,
          clubFacilitySafetyActionPlanFile: false,
          clubFacilitySafetyActionPlanFileUrl: '',
          clubFacilitySafetyActionPlanFileName: ''
        });
      } else if (type === FACILITY_CONTRACT) {
        setFileState({
          ...fileState,
          clubFacilityContractFile: false,
          clubFacilityContractFileUrl: '',
          clubFacilityContractFileName: ''
        });
      }

      if (type === EMERGENCY_ACTION_PLAN) {
        setFileRemoveState({ ...fileRemoveState, isEAPFileRemoved: true });
      } else if (type === SAFETY_ACTION_PLAN) {
        setFileRemoveState({ ...fileRemoveState, isSAPFileRemoved: true });
      } else if (type === FACILITY_CONTRACT) {
        setFileRemoveState({ ...fileRemoveState, isContractFileRemoved: true });
      } 
    }
  }

  const onOpenRemoveFileModalClicked = (e, fileType) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    let fileNameVal = '';
    let fileTypeVal = '';

    if (fileType === EMERGENCY_ACTION_PLAN_TYPE) {
      fileNameVal = fileState.clubFacilityEmergencyActionPlanFileName;
      fileTypeVal = EMERGENCY_ACTION_PLAN;
    } else if (fileType === SAFETY_ACTION_PLAN_TYPE) {
      fileNameVal = fileState.clubFacilitySafetyActionPlanFileName;
      fileTypeVal = SAFETY_ACTION_PLAN;
    } else if (fileType === FACILITY_CONTRACT_TYPE) { 
      fileNameVal = fileState.clubFacilityContractFileName;
      fileTypeVal = FACILITY_CONTRACT;
    }
    
    setRemoveFileModalState({
      ...removeFileModalState,
      fileType: fileTypeVal,
      fileName: fileNameVal,
      displayPopUp: true
    });
  }

  const onRemoveFileModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setRemoveFileModalState({ ...getInitialRemoveFileModalState() });
  }

  const onDownloadUploadedFile = (e, fileUrl) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    showUploadedFile(fileUrl);
  }

  useEffect(() => {
    if (clubRegistrationState.isObjLoaded === false) {
      navigate(NavLinks.CLUB_REGISTRATION_ENTRY_NEW);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
        fileRemoveState.isEAPFileRemoved === true || 
        fileRemoveState.isSAPFileRemoved === true || 
        fileRemoveState.isContractFileRemoved === true) {
      putUsasClubFacilityLinks(clubRegistrationState.objData.usasClubId, formState.orgUnitFacilityId, constructObjectForUpdate());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileRemoveState]);

  useEffect(() => {
    if (location.state && location.state.facilityId
      && location.state.isNewFacility === true) {

      getUsasClubFacilityLinks(clubRegistrationState.objData.usasClubId);
      setState({ ...state, isFacilityInClubObj: true, facilityId: location.state.facilityId, isNewFacility: true });
    }
    else if (location.state && location.state.facilityId
      && location.state.isNewFacility === undefined) {
      setState({ ...state, isFacilityInClubObj: true, facilityId: location.state.facilityId, isNewFacility: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (usasClubFacilityLinksState.isArrayLoaded === true && usasClubFacilityLinksState.isSaving === false) {
      if (state.isFacilityInClubObj === true && state.facilityId > 0) {
        const selectedFacility = usasClubFacilityLinksState.arrayData.find((facility) => facility.facilityId === state.facilityId)

        let eapUrl = selectedFacility.clubFacilityEmergencyActionPlanUrl !== null ? selectedFacility.clubFacilityEmergencyActionPlanUrl : '';
        let sapUrl = selectedFacility.clubFacilitySafetyActionPlanUrl !== null ? selectedFacility.clubFacilitySafetyActionPlanUrl : '';
        let contractUrl = selectedFacility.clubFacilityContractUrl !== null ? selectedFacility.clubFacilityContractUrl : '';  
        
        let eapFileName = selectedFacility.clubFacilityEmergencyActionPlanUrl !== null ? getFileNameFromUrl(selectedFacility.clubFacilityEmergencyActionPlanUrl) : '';
        let sapFileName = selectedFacility.clubFacilitySafetyActionPlanUrl !== null ? getFileNameFromUrl(selectedFacility.clubFacilitySafetyActionPlanUrl) : '';
        let contractFileName = selectedFacility.clubFacilityContractUrl !== null ? getFileNameFromUrl(selectedFacility.clubFacilityContractUrl) : '';

        eapUrl = eapUrl === '' ? fileState.clubFacilityEmergencyActionPlanFileUrl : eapUrl;
        sapUrl = sapUrl === '' ? fileState.clubFacilitySafetyActionPlanFileUrl : sapUrl;
        contractUrl = contractUrl === '' ? fileState.clubFacilityContractFileUrl : contractUrl; 

        eapFileName = eapFileName === '' ? fileState.clubFacilityEmergencyActionPlanFileName : eapFileName;
        sapFileName = sapFileName === '' ? fileState.clubFacilitySafetyActionPlanFileName : sapFileName;
        contractFileName = contractFileName === '' ? fileState.clubFacilityContractFileName : contractFileName;

        setFileState({
          ...fileState,
          clubFacilityEmergencyActionPlanFileUrl: fileRemoveState.isEAPFileRemoved === false ? eapUrl : '',
          clubFacilityEmergencyActionPlanFileName: fileRemoveState.isEAPFileRemoved === false ? eapFileName : '',
          clubFacilitySafetyActionPlanFileUrl: fileRemoveState.isSAPFileRemoved === false ? sapUrl : '',
          clubFacilitySafetyActionPlanFileName: fileRemoveState.isSAPFileRemoved === false ? sapFileName : '',
          clubFacilityContractFileUrl: fileRemoveState.isContractFileRemoved === false ? contractUrl : '',
          clubFacilityContractFileName: fileRemoveState.isContractFileRemoved === false ? contractFileName : ''
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usasClubFacilityLinksState, state]);

  useEffect(() => {
    if (usasClubFacilityLinksState.isArrayLoaded === true && usasClubFacilityLinksState.isSaving === false) {
      if (state.isFacilityInClubObj === true && state.facilityId > 0) {
        const selectedFacility = usasClubFacilityLinksState.arrayData.find((facility) =>
          facility.facilityId === state.facilityId)

        let trainingFacilityVal = selectedFacility.trainingFacility !== undefined && selectedFacility.trainingFacility !== null ? selectedFacility.trainingFacility : '';
        let trainingFacilityDisplayVal = formState.trainingFacility === '' ? trainingFacilityVal : formState.trainingFacility;

        let includeInTeamFinderVal = selectedFacility.clubFacilityIncludeOnFindATeam !== undefined && selectedFacility.clubFacilityIncludeOnFindATeam !== null ? selectedFacility.clubFacilityIncludeOnFindATeam : '';
        let includeInTeamFinderDisplayVal = formState.includeInTeamFinder === '' ? includeInTeamFinderVal : formState.includeInTeamFinder;

        setFormState({
          ...formState,
          facilityId: selectedFacility.facilityId || Constants.DEFAULT_ID,
          facilityName: selectedFacility.facility.facilityName || '',
          address1: selectedFacility.facility.address1 || '',
          address2: selectedFacility.facility.address2 || '',
          city: selectedFacility.facility.city || '',
          stateCode: selectedFacility.facility.stateCode || '',
          postalCode: selectedFacility.facility.postalCode || '',
          contactName: formState.contactName === '' ? selectedFacility.facility.contactName : formState.contactName || '',
          contactEmailAddress: formState.contactEmailAddress === '' ? selectedFacility.facility.contactEmailAddress : formState.contactEmailAddress || '',
          contactPhoneNumber: formState.contactPhoneNumber === '' ? selectedFacility.facility.contactPhoneNumber : formState.contactPhoneNumber || '',
          hostMeet: selectedFacility.facility.hostMeet || '',
          clubFacilityContactName: formState.clubFacilityContactName === '' ? selectedFacility.clubFacilityContactName || '' : formState.clubFacilityContactName || '',
          clubFacilityContactEmailAddress: formState.clubFacilityContactEmailAddress === '' ? selectedFacility.clubFacilityContactEmailAddress || '' : formState.clubFacilityContactEmailAddress || '',
          clubFacilityContactPhoneNumber: formState.clubFacilityContactPhoneNumber === '' ? selectedFacility.clubFacilityContactPhoneNumber || '' : formState.clubFacilityContactPhoneNumber || '',
          orgUnitFacilityId: selectedFacility.orgUnitFacilityId || Constants.DEFAULT_ID,
          orgUnitId: selectedFacility.orgUnitId || '',
          trainingFacility: trainingFacilityDisplayVal, 
          includeInTeamFinder: includeInTeamFinderDisplayVal, 
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usasClubFacilityLinksState, state]);

  useEffect(() => {
    if (usasClubFacilityLinksState.isArrayLoaded === true && usasClubFacilityLinksState.isSaving === false && state.tryRedirect === true
      && isSubmitting === false && Object.keys(errorState).length === 0) {
      if (state.isNewFacility === true) {
        navigate(NavLinks.CLUB_REGISTRATION_FACILITY_POOL_DETAIL, { state: { facilityId: state.facilityId } });
      }
      else if (state.isNewFacility === false) {
        navigate(NavLinks.CLUB_REGISTRATION_FACILITY, { state: { hasNewFacilityDetails: true } });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usasClubFacilityLinksState, state, isSubmitting, errorState])

  useEffect(() => {
    if (usasClubFileUploadState.isObjLoaded === true && Object.keys(usasClubFileUploadState.objData).length > 0) {
      if (fileState.clubFacilityEmergencyActionPlanFile === true) {
        setFileState({
          ...fileState,
          clubFacilityEmergencyActionPlanFile: false,
          clubFacilityEmergencyActionPlanFileUrl: usasClubFileUploadState.objData.uploadUrl,
          clubFacilityEmergencyActionPlanFileName: getFileNameFromSavedUploadUrl()
        });
        putUsasClubFacilityLinks(clubRegistrationState.objData.usasClubId, formState.orgUnitFacilityId, constructObjectForFileUpload(EMERGENCY_ACTION_PLAN, usasClubFileUploadState.objData.uploadUrl));
      }
      else if (fileState.clubFacilitySafetyActionPlanFile === true) {
        setFileState({
          ...fileState,
          clubFacilitySafetyActionPlanFile: false,
          clubFacilitySafetyActionPlanFileUrl: usasClubFileUploadState.objData.uploadUrl,
          clubFacilitySafetyActionPlanFileName: getFileNameFromSavedUploadUrl()
        });
        putUsasClubFacilityLinks(clubRegistrationState.objData.usasClubId, formState.orgUnitFacilityId, constructObjectForFileUpload(SAFETY_ACTION_PLAN, usasClubFileUploadState.objData.uploadUrl));
      } else if (fileState.clubFacilityContractFile === true) {
        setFileState({
          ...fileState,
          clubFacilityContractFile: false,
          clubFacilityContractFileUrl: usasClubFileUploadState.objData.uploadUrl,
          clubFacilityContractFileName: getFileNameFromSavedUploadUrl()
        });
        putUsasClubFacilityLinks(clubRegistrationState.objData.usasClubId, formState.orgUnitFacilityId, constructObjectForFileUpload(FACILITY_CONTRACT, usasClubFileUploadState.objData.uploadUrl));
      } 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usasClubFileUploadState, fileState])

  async function showUploadedFile(fileUrl) {
    if (fileUrl) {
      const getFileResult = await getUsasClubFile(fileUrl);

      if (getFileResult) {
        if (getFileResult.objData?.blobFile?.size > 0) {
          var file = window.URL.createObjectURL(getFileResult.objData?.blobFile);
          const link = document.createElement('a');

          link.href = file;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      }
    }
  }

  return {
    usasClubFacilityLinksState,
    clubRegistrationState,
    clubRegistrationNavState,
    formState,
    errorState,
    fileState,
    removeFileModalState,
    onSaveClicked,
    handleSubmit,
    onFormValueChanged,
    onValueTextPairChanged,
    onCancelGoToClubRegistrationFacilities,
    onUploadDocumentClicked,
    onRemoveDocumentClicked,
    onOpenRemoveFileModalClicked,
    onRemoveFileModalCanceled,
    onDownloadUploadedFile
  };

  function getInitialRemoveFileModalState() {
    return {
      displayPopUp: false,
      fileType: '',
      fileName: '',
      modalTitle: FILE_MODAL_TITLE
    }
  }

  function getInitialClubFacilityState() {
    return {
      facilityId: Constants.DEFAULT_ID,
      facilityName: '',
      address1: '',
      address2: '',
      city: '',
      stateCode: '',
      postalCode: '',
      contactName: '',
      contactEmailAddress: '',
      contactPhoneNumber: '',
      hostMeet: false,
      clubFacilityContactName: '',
      clubFacilityContactEmailAddress: '',
      clubFacilityContactPhoneNumber: '',
      orgUnitFacilityId: Constants.DEFAULT_ID,
      orgUnitId: '',
      trainingFacility: '',
      includeInTeamFinder: '',
      clubFacilityEmergencyActionPlanUrl: ''
    };
  };
}

export default useClubRegistrationFacilityDetails;